import { ICanvasStep } from '../interfaces'

export const codeExists = (code: string, steps: ICanvasStep[]) => steps.some(step => step.code === code)
